<template>
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative z-[60]" @close="closeModal">
            <!-- Backdrop -->
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <!-- Content -->
            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel class="relative transform overflow-hidden rounded-2xl bg-white px-4 pb-4 pt-5 text-left shadow-2xl shadow-slate-900/10 transition-all sm:my-8 sm:w-full sm:max-w-4xl sm:p-6">
                            <PrintCalculation
                                :rooms="calcStore.getRooms"
                                :total-panels="calcStore.totalPanels"
                                :total-ceilings="calcStore.totalCeilings"
                                :total-floorings="calcStore.totalFloorings"
                            />
                            <div class="no-print mt-5 sm:mt-6">
                                <button
                                    type="button"
                                    class="inline-flex w-full cursor-pointer justify-center rounded-xl bg-white px-3 py-2.5 text-sm font-semibold text-slate-700 shadow-sm ring-1 ring-slate-200 ring-inset hover:bg-slate-50"
                                    @click="closeModal"
                                >
                                    Close
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { useCalculatorStore } from '@/stores/calculator-store.js';
import PrintCalculation from '@/components/Portal/Calculator/PrintCalculation.vue';
import { ref } from 'vue';

const emits = defineEmits(['closeModal']);
const open = ref(true);

const calcStore = useCalculatorStore();

const closeModal = () => {
    open.value = false;
    emits('closeModal');
};

</script>


<style scoped>

</style>